export default "__VITE_ASSET__BjJgv2Ev__"